module.exports = ".count-text {\n  font-size: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/widget/count-widget/count-widget.component.scss
// module id = ./src/app/components/account/widget/count-widget/count-widget.component.scss
// module chunks = main